import { activeApplicationStatuses, normalizeApplicationStatus } from '../../../shared/src/utils/applicationStatus';
export const applicationStatuses = [...activeApplicationStatuses];
export function parseApplicationFilters(params: URLSearchParams) {
  const group = params.get('group') || '';
  const status = normalizeApplicationStatus(params.get('status') || '');
  const rawPage = params.get('page') || '1';
  const error = (params.getAll('group').length > 1 || params.getAll('status').length > 1 || (group && !['pending', 'approved'].includes(group)) || (status && !applicationStatuses.some(value => value === status)) || (group && status) || !/^[1-9]\d*$/.test(rawPage) || !Number.isSafeInteger(Number(rawPage))) ? 'Invalid application filters. Reset to view your applications.' : '';
  return { group: group as '' | 'pending' | 'approved', status, search: params.get('search') || '', page: error ? 1 : Number(rawPage), error };
}
export function updateApplicationFilters(params: URLSearchParams, changes: Record<string, string>) {
  const next = new URLSearchParams(params);
  next.delete('page');
  for (const [key, value] of Object.entries(changes)) value ? next.set(key, value) : next.delete(key);
  return next;
}
